import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-grouping-quiz-list',
  templateUrl: './nav-grouping-quiz-list.component.html',
  styleUrls: ['./nav-grouping-quiz-list.component.css']
})
export class NavGroupingQuizListComponent implements OnInit {
  @Input() subscriptionGrouping:Object = undefined
  server_subscription_grouping_id:number=undefined
  constructor() { }

  ngOnInit(): void {
    if(this.subscriptionGrouping){
       this.server_subscription_grouping_id=this.subscriptionGrouping['server_subscription_grouping_id']
      }
  }

}
